import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { handleResponseThrowError } from '@/_utils/services';
import { apiClientOld } from '@/_config/lib/axios/api-client-old';
import { GET_BALANCE_DELIVERYMAN } from './constants';
import type { Balance } from './types';

type GetBalanceDeliverymanParams = {
  deliverymanId: string;
};

const getBalanceDeliveryman = (params: GetBalanceDeliverymanParams) => {
  const { deliverymanId } = params;

  return apiClientOld
    .get<Balance>(`/entregadores/${deliverymanId}/bank/saldo`)
    .then(response => response.data)
    .catch(handleResponseThrowError());
};

type GetBalanceDeliverymanResponse = Awaited<
  ReturnType<typeof getBalanceDeliveryman>
>;

export const useGetBalanceDeliveryman = (
  params: GetBalanceDeliverymanParams,
  options: Omit<
    UseQueryOptions<
      GetBalanceDeliverymanResponse,
      unknown,
      GetBalanceDeliverymanResponse,
      (string | GetBalanceDeliverymanParams)[]
    >,
    'queryKey' | 'queryFn'
  > = {},
) => {
  return useQuery({
    queryKey: [GET_BALANCE_DELIVERYMAN, params],
    queryFn: () => getBalanceDeliveryman(params),
    ...options,
  });
};
